import {
  IncentiveOffer,
  IncentivesMarketBeneficiary,
  IncentivesMarketBeneficiaryAddress,
} from 'modules/incentivesMarket/types';

import { CustomAsyncSelectOption } from 'modules/_shared/components/CustomAsyncSelect/types/CustomAsyncSelectOption';
import { PublisherPartner } from '../types/PublishIncentiveOfferModalContextType';

type IncentiveOfferDraft = Partial<IncentiveOffer> & { className: string };

const emptyAddress = (): IncentivesMarketBeneficiary['address'] => ({
  line1: '',
  zip: '',
  city: '',
  state: '',
  country: '',
});

const normalizeAddress = (
  addr?: Partial<IncentivesMarketBeneficiaryAddress> | null
): IncentivesMarketBeneficiary['address'] =>
  addr
    ? {
        line1: addr.line1 || '',
        zip: addr.zip || '',
        city: addr.city || '',
        state: addr.state || '',
        country: addr.country || '',
      }
    : emptyAddress();

const beneficiaryIdFromOffer = (offer: IncentiveOfferDraft): string | undefined => {
  const { beneficiary } = offer;
  if (!beneficiary) return undefined;
  if (typeof beneficiary === 'string') return beneficiary;
  return beneficiary._id;
};

export const buildInitialPublisherBeneficiary = (
  publisherPartnerProp: PublisherPartner | null | undefined,
  incentiveOffer: IncentiveOfferDraft
): PublisherPartner | null => {
  if (publisherPartnerProp) {
    return {
      ...publisherPartnerProp,
      address: normalizeAddress(publisherPartnerProp.address),
    };
  }

  const beneficiaryId = beneficiaryIdFromOffer(incentiveOffer);
  if (!beneficiaryId) return null;

  return {
    _id: beneficiaryId,
    name: '',
    cif: '',
    email: '',
    phone: '',
    bankAccountNumber: '',
    address: emptyAddress(),
  };
};

export const mapBeneficiaryOptionToPartialBeneficiary = (
  selectedBeneficiaryId: string,
  option: CustomAsyncSelectOption | null
): Partial<IncentivesMarketBeneficiary> | null => {
  if (!selectedBeneficiaryId) return null;

  if (option && option.value === selectedBeneficiaryId) {
    return {
      _id: selectedBeneficiaryId,
      name: option.name || '',
      cif: option.cif || '',
      email: option.email || '',
      phone: '',
      bankAccountNumber: '',
      address: normalizeAddress(option.address),
    };
  }

  return {
    _id: selectedBeneficiaryId,
    name: '',
    cif: '',
    email: '',
    phone: '',
    bankAccountNumber: '',
    address: emptyAddress(),
  };
};
